import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {TasksReportsApiService} from '../../../../../Services/Api/Reports/Tasks/tasks-reports-api.service';
import {AuditReportDto} from '../../../../../Models/Reports/Tasks/Audit/audit-report.interface';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {TasksReportFilters} from '../../../../../Models/Reports/Tasks/Shared/tasks-report-filters.model';

@Component({
  selector: 'app-audit-valuation-widget',
  templateUrl: './audit-valuation-widget.component.html',
  styleUrls: ['./audit-valuation-widget.component.scss'],
  standalone: false
})
export class AuditValuationWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 33;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected tasksReportsService: TasksReportsApiService,
  ) {
    super(injector, tasksReportsService);
  }


  /**
   * Obtener la valoración de las auditorías
   *
   */
  override setData(data: AuditReportDto) {
    this.data = data ? Math.round(data.valoracion_global.base) : 0;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: TasksReportFilters = new TasksReportFilters();

    if (this.widgetsManager.filters) {
      filters.id_local = this.widgetsManager.filters.local?.id ? [this.widgetsManager.filters.local.id] : [];
      filters.fecha_inicio = this.widgetsManager.filters.fecha_inicio || filters.fecha_inicio;
      filters.fecha_fin = this.widgetsManager.filters.fecha_fin || filters.fecha_fin;
    }

    return this.tasksReportsService.getAuditsReport(filters);
  }

}
